import axios from '@/http'

export default {
  state: {
    type: [],
    state:{
      "1":{
        text:'待转交',
        type:'warning'
      },
      "2": {
        text: '待回复',
        type: ''
      },
      "3": {
        text: '已回复',
        type: 'success'
      },
      "4": {
        text: '公布',
        type: 'info'
      },
      "5": {
        text: '待公布',
        type: 'info'
      },
    }
  },
  actions: {
    getType({ commit},data){
      return new Promise((resolve, reject) => {
        axios.get('/complaintType').then(res=>{
          const data = res.data.records.map(item=>{
            return{
              name: item.complaint_type_name,
              id: item.complaint_type_id
            }
          });
          commit('set_suggestionType',data)
          resolve(data)
        }).catch(err=>{
          reject(err)
        })
      })
    }
  },
  mutations: {
    set_suggestionType(state, data) {
      state.type = data
    }
  }
}